<template>
  <el-main>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Estratégico" :name="1">
        <GanttObjectives :Strategic="2" v-if="activeName == 1" />
      </el-tab-pane>
      <el-tab-pane label="Operacionales" :name="2">
        <GanttObjectives :Strategic="1" v-if="activeName == 2" />
      </el-tab-pane>
      <el-tab-pane label="KPI Gerencia" :name="3">
        <KpiTaskGanttTabs />
      </el-tab-pane>
      <el-tab-pane label="KPI Empleado" :name="4">
        <DashboardGantt />
      </el-tab-pane>
      <el-tab-pane label="Reporte de Objetivos" :name="5">
        <ObjectivesReport :actualTab="activeName" />
      </el-tab-pane>
    </el-tabs>
  </el-main>
</template>

<script>
import GanttObjectives from "./GanttObjectives.vue";
import KpiTaskGanttTabs from "../tasks/kpiTaskGanttTabs.vue";
import DashboardGantt from "@/views/apps/cmi/objetives/DashboardGantt.vue";
import ObjectivesReport from "@/views/apps/cmi/ObjectivesReport/ObjectivesReport";
export default {
  components: {
    GanttObjectives,
    KpiTaskGanttTabs,
    DashboardGantt,
    ObjectivesReport
  },
  name: "GanttMain",
  data() {
    return {
      activeName: 1
    };
  }
};
</script>

<style></style>
